//--------------------------------------->
//-->  Data fot the Middle section
//--------------------------------------->

const Content = {
  title: `Geo location intelligence
 at your finger tips`,
  content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur tempus urna at turpis condimentum lobortis.`,
};

export default Content;
